import {
  ROOT,
  USER_LOGIN,
  FORGOT_PASSWORD,
  USER_LOGIN_ADMIN,
  USER_LOGIN_TOKEN,
  USER_UPDATE_CHAT_ID,
  EZID_LOGIN
} from "@/_helpers/constant.js";
import { BehaviorSubject } from "rxjs";
import { requestOptions, handleResponse } from "@/_helpers";
import idsrvAuth from "@/Auth.js";

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);

export const authenticationService = {
  getAllCurrency,
  login,
  logout,
  forgotPassword,
  currentUser: currentUserSubject.asObservable(),
  loginAdmin,
  loginToken,
  updateChatId,
  loginEzId,
  getApp,
  get currentUserValue() {
    return currentUserSubject.value;
  }
};

function getAllCurrency() {
  return fetch(ROOT + '/api/v2/hotel/info/currency/get-all', requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getApp() {
  return fetch(ROOT + '/api/v2/hotel/user/get-app', requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateChatId(id) {
  return fetch(ROOT + USER_UPDATE_CHAT_ID + `?chatId=${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function login(username, password) {
  return fetch(ROOT + USER_LOGIN, requestOptions.post({ username, password }))
    .then(handleResponse)
    .then(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("currentUser", JSON.stringify(user.data));
      // currentUserSubject.next(user.data);
      // localStorage.setItem("showmenuchain", JSON.stringify(false));
      return user;
    });
}

function loginEzId(token) {
  return fetch(ROOT + EZID_LOGIN, requestOptions.post({ 'token': token }))
    .then(handleResponse)
    .then(user => {
      let localArrToken = [];
      localArrToken.push({
        hotel: user.data.hotel,
        token: user.data.token
      });
      localStorage.setItem("arrToken", JSON.stringify(localArrToken));
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("currentUser", JSON.stringify(user.data));
      currentUserSubject.next(user.data);
      localStorage.setItem("showmenuchain", JSON.stringify(false));
      return user;
    });
}

function loginAdmin(username, password, hotelId) {
  return fetch(
    ROOT + USER_LOGIN_ADMIN,
    requestOptions.post({ username, password, hotelId })
  )
    .then(handleResponse)
    .then(res => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("currentUser", JSON.stringify(res.data));
      currentUserSubject.next(res.data);
      return res;
    });
}

function loginToken(token) {
  let authHeader = { Authorization: "Token " + token };
  return fetch(ROOT + USER_LOGIN_TOKEN, {
    method: "GET",
    headers: {
      Authorization: authHeader.Authorization
    }
  })
    .then(handleResponse)
    .then(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("currentUser", JSON.stringify(user.data));
      currentUserSubject.next(user.data);

      return user;
    });
}

function logout(reload = true) {
  // remove user from local storage to log user out
  localStorage.removeItem("currentUser");
  localStorage.removeItem("arrToken");
  localStorage.removeItem("listI18ns");
  //localStorage.removeItem("systemLanguage");
  idsrvAuth.signoutRedirect();
  currentUserSubject.next(null);
  // if (reload) {
  //   window.location.reload();
  // }
}

function forgotPassword(username) {
  return fetch(ROOT + FORGOT_PASSWORD, requestOptions.post({ username }))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
